<template>
    <div class="page-container">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">系统设置</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>推送设置</el-breadcrumb-item>
        </el-breadcrumb>
        <el-card class="page-content" shadow="never">
           <el-tabs @tab-click="handleClick" v-model="activeName">
               <el-tab-pane label="人工提醒推送" name="artificialRemind">
                   <artificial-remind></artificial-remind>
               </el-tab-pane>
               <el-tab-pane label="行情自动推送" name="quotation">
                   <quotation></quotation>
               </el-tab-pane>
               <el-tab-pane label="推送开关和服务商设置" name="pushServiceProvider"  v-if="rightsContains('AUTHORITY_SETTING')">
                   <el-radio-group v-model="pushProviderType" style="margin-right: 20px;">
                       <el-radio label="XIN_GE_PUSH" border>信鸽推送</el-radio>
                       <el-radio label="JI_GUANG_PUSH" border>极光推送</el-radio>
                   </el-radio-group>
                   <el-button type="primary" @click="savePushServiceProvider()">保存</el-button>
                   <el-table :data="pushSwitch">
                       <el-table-column label="推送类型" prop="name">
                           <template slot-scope="scope">
                               {{parseCodeToDesc(scope.row.name,notifyType)}}
                           </template>
                       </el-table-column>
                       <el-table-column label="开关">
                           <template slot-scope="scope">
                               <el-switch v-model="scope.row.value" active-color="#13ce66" inactive-color="#ff4949" @change="savePushSwitchInfo(scope.row)"></el-switch>
                           </template>
                       </el-table-column>
                   </el-table>
               </el-tab-pane>
           </el-tabs>
        </el-card>
    </div>
</template>

<script>
    import artificialRemind from './components/remind/index';
    import quotation from './components/quotation';
    import {mapState, mapActions} from 'vuex';
    import './store';
    import api from './api';
    import { RIGHTS_TYPE } from "../../../common/constant";
    export default {
        name: "pushSetting",
        components:{
            artificialRemind,
            quotation
        },
        data(){
            return{
                activeName:'artificialRemind',
                pushProviderType:'',
                pushSwitch:[],
                notifyType:[
                    {code:'PUSH_SWITCH_KEY_DEPOSIT_SUCC',desc:'充值成功'},
                    {code:'PUSH_SWITCH_KEY_CURRENT_INTEREST_SUCC',desc:'活期宝利息发放完成'},
                    {code:'PUSH_SWITCH_KEY_PLEDGE_INTEREST_SUCC',desc:'定期宝利息发放完成'},
                    {code:'PUSH_SWITCH_KEY_ORDER_FINISHED',desc:'订单完成'},
                    {code:'PUSH_SWITCH_KEY_WITHDRAW_APPROVED',desc:'提现审核成功'},
                    {code:'PUSH_SWITCH_KEY_C2C_MERCHANT_PROCESSED',desc:'C2C商家放币成功'},
                    {code:'PUSH_SWITCH_KEY_KYC_APPROVED',desc:'KYC成功通过'},
                    {code:'PUSH_SWITCH_KEY_USER_QUOTATION_PRICE_UP',desc:'用户行情预警成交价突破预警值'},
                    {code:'PUSH_SWITCH_KEY_USER_QUOTATION_PRICE_DOWN',desc:'用户行情预警成交价跌破预警值'},
                    {code:'PUSH_SWITCH_KEY_USER_QUOTATION_PRICE_RISE',desc:'用户5分钟内涨幅超过'},
                    {code:'PUSH_SWITCH_KEY_USER_QUOTATION_PRICE_DROP',desc:'用户5分钟内跌幅超过'},
                    {code:'PUSH_SWITCH_KEY_OTC_ORDER_CREATE',desc:'OTC订单创建'},
                    {code:'PUSH_SWITCH_KEY_OTC_ORDER_PAYMENT',desc:'OTC订单支付'},
                    {code:'PUSH_SWITCH_KEY_OTC_ORDER_TRANSFER',desc:'OTC订单转让'},
                    {code:'PUSH_SWITCH_KEY_OTC_ORDER_CANCEL',desc:'OTC订单取消'},
                    {code:'PUSH_SWITCH_KEY_OTC_ALLEGE_ALLEGE_AUDIT_YES',desc:'PUSH_SWITCH_KEY_OTC_ALLEGE_ALLEGE_AUDIT_YES'},
                    ]
            }
        },
        computed: {
            ...mapState(["userInfo", "userRights"])
        },
        methods:{
            ...mapActions('pushSetting',['queryQuotationPushConf']),
            handleClick(tab){
                if (tab.name === 'quotation') {
                    this.queryQuotationPushConf({});
                }
                if (tab.name === 'pushServiceProvider'){
                    api.queryPushProviderType().then(response =>{
                        this.pushProviderType = response.data;
                    });
                    api.queryPushSwitch().then(response => {
                        this.pushSwitch = response.data;
                    })
                }
            },
            savePushServiceProvider(){
                api.savePushProviderType({pushProviderType:this.pushProviderType}).then(() =>{
                    this.$message.success('保存成功')
                })
            },
            rightsContains(r) {
                let rights = this.userRights.split(",") || [];
                return rights.indexOf(RIGHTS_TYPE[r]) !== -1;
            },
            savePushSwitchInfo(row){
                 api.savePushSwitch({notifyType:row.name,open:row.value}).then(()=>{this.$message.success('设置成功')})
            },
            parseCodeToDesc(code,infos){
                for (let index in infos){
                    if (infos[index].code == code){
                        return infos[index].desc;
                    }
                }
            },
        }
    }
</script>

<style scoped>

</style>